var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-profile-container"},[_c('div',{staticClass:"user-info-content"},[_c('div',{staticClass:"username"},[_vm._v(_vm._s(_vm.profile.username))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-item"},[_c('span')])
}]

export { render, staticRenderFns }